import { ligainicial } from "./rutainicial.js";
import { pagesipdus } from "./rutainicial";

const ligabase = ligainicial + "2026/Lic/C";
const ligasipdus = pagesipdus + "2026/Lic/C";

export const licitacionesVigentes = [
    {
        // CONVOCATORIA NUM# 031
        'numConvocatoria' : 'Convocatoria No. 031/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N86-2026.',
        'vigencia' : '20 al 24 de julio de 2026.',
        'descripcionProcedimiento' : 'Infraestructura complementaria del complejo "Hidalgo Honesto".; ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo (Segundo procedimiento).',
        'urlAnexos' : `${ ligasipdus }31/N86/N86.rar`,
        'start' : '2026-07-20',
        'end' : '2026-07-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 030
        'numConvocatoria' : 'Convocatoria No. 030/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N85-2026.',
        'vigencia' : '20 de julio al 3 de agosto de 2026.',
        'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Dr, Luis Ponce Romero, tramo calle José Ma. Bandera a Viaducto Javier Rojo Gómez, colonia Doctores, en municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }30/N85/N85.rar`,
        'start' : '2026-07-20',
        'end' : '2026-08-03',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 029
        'numConvocatoria' : 'Convocatoria No. 029/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N84-2026.',
        'vigencia' : '20 de julio al 3 de agosto de 2026.',
        'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Rio Alvarado colonia ampliación El Palmar, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }29/N84/N84.rar`,
        'start' : '2026-07-20',
        'end' : '2026-08-03',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N83-2026.',
        'vigencia' : '20 de julio al 3 de agosto de 2026.',
        'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle avenida 1 entre Av. Magisterio y Av. Insurgentes, colonia Piracantos, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }29/N83/N83.rar`,
        'start' : '2026-07-20',
        'end' : '2026-08-03',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N82-2026.',
        'vigencia' : '20 de julio al 3 de agosto de 2026.',
        'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en camino hacia el panteón, localidad de Palo Gordo, en el municipio de Metepec.; ubicada en la localidad de Palo Gordo (Ejido Nopalillo), Municipio de Metepec, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }29/N82/N82.rar`,
        'start' : '2026-07-20',
        'end' : '2026-08-03',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N81-2026.',
        'vigencia' : '20 de julio al 3 de agosto de 2026.',
        'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en calle principal de la comunidad de tlatepexe, en el municipio de Metztititlán.; ubicada en la localidad y Municipio de Metztitlán, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }29/N81/N81.rar`,
        'start' : '2026-07-20',
        'end' : '2026-08-03',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N80-2026.',
        'vigencia' : '20 de julio al 3 de agosto de 2026.',
        'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Felipe Ángeles colonia Cuauhtémoc, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }29/N80/N80.rar`,
        'start' : '2026-07-20',
        'end' : '2026-08-03',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N79-2026.',
        'vigencia' : '20 de julio al 3 de agosto de 2026.',
        'descripcionProcedimiento' : 'Pavimento de concreto hidráulico en calle Jaime Nunó, colonia Periodistas, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }29/N79/N79.rar`,
        'start' : '2026-07-20',
        'end' : '2026-08-03',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N78-2026.',
        'vigencia' : '20 al 31 de julio de 2026.',
        'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en cale de acceso a la comunidad de Nopalillo, en el municipio de Metepec.; ubicada en la localidad de Nopalillo, Municipio de Metepec, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }29/N78/N78.rar`,
        'start' : '2026-07-20',
        'end' : '2026-07-31',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N77-2026.',
        'vigencia' : '20 al 31 de julio de 2026.',
        'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico en libramiento C. José Francisco Osorno, en el municipio de Apan.; ubicada en la localidad de Las Haciendas, Municipio de Apan, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }29/N77/N77.rar`,
        'start' : '2026-07-20',
        'end' : '2026-07-31',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N76-2026.',
        'vigencia' : '20 al 31 de julio de 2026.',
        'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en la calle Begonia,colonia Progreso, en el municipio de Pachuca de Soto.; ubicada en Varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }29/N76/N76.rar`,
        'start' : '2026-07-20',
        'end' : '2026-07-31',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N75-2026.',
        'vigencia' : '20 al 31 de julio de 2026.',
        'descripcionProcedimiento' : 'Pavimentación de concreto Hidráulico en calle Gardenia colonia Jardines de colosio, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }29/N75/N75.rar`,
        'start' : '2026-07-20',
        'end' : '2026-07-31',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N74-2026.',
        'vigencia' : '20 al 31 de julio de 2026.',
        'descripcionProcedimiento' : 'Reconstrucción de la C. E. Tulancingo-Huasca (tramo Acatlán-Hacienda El Lucero), en el municipio de Acatlán.; ubicada en Varias localidades del Municipio de Acatlán, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }29/N74/N74.rar`,
        'start' : '2026-07-20',
        'end' : '2026-07-31',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N73-2026.',
        'vigencia' : '20 al 31 de julio de 2026.',
        'descripcionProcedimiento' : 'Pavimentación d concreto hidráulico en calle San Juan Pachuca, colonia centro, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }29/N73/N73.rar`,
        'start' : '2026-07-20',
        'end' : '2026-07-31',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N72-2026.',
        'vigencia' : '20 al 31 de julio de 2026.',
        'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Miguel Hidalgo, colonia Venta Prieta, en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
        'urlAnexos' : `${ ligasipdus }29/N72/N72.rar`,
        'start' : '2026-07-20',
        'end' : '2026-07-31',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N71-2026.',
        'vigencia' : '20 al 31 de julio de 2026.',
        'descripcionProcedimiento' : 'Reconstrucción de la carretera intermunicipal de Tolcayuca a Zapotlán de Juárez, en el municipio de Tolcayuca.; ubicada en la localidad y Municipio de Tolcayuca, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }29/N71/N71.rar`,
        'start' : '2026-07-20',
        'end' : '2026-07-31',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N70-2026.',
        'vigencia' : '20 al 31 de julio de 2026.',
        'descripcionProcedimiento' : 'Modernización de carretera Tlaxcoapan-Apaxco (tramo San José Bojay-límites con Atotonilco de Tula) con concreto hidráulico, municipio de Atitalaquia.; ubicada en la localidad y Municipio de Atitalaquia, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }29/N70/N70.rar`,
        'start' : '2026-07-20',
        'end' : '2026-07-31',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N69-2026.',
        'vigencia' : '20 al 31 de julio de 2026.',
        'descripcionProcedimiento' : 'Modernización de carretera Tlaxcoapan-Apaxco (Texas-limites con Atitalaquia) con concreto hidráulico, en el municipio Atotonilco de Tula.; ubicada en la localidad de Texas, Municipio de Atotonilco de Tula, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }29/N69/N69.rar`,
        'start' : '2026-07-20',
        'end' : '2026-07-31',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N68-2026.',
        'vigencia' : '20 al 31 de julio de 2026.',
        'descripcionProcedimiento' : 'Ampliación de la avenida constructores entronque boulevard Felipe Ángeles y boulevard Luis D. Colosio,en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }29/N68/N68.rar`,
        'start' : '2026-07-20',
        'end' : '2026-07-31',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N67-2026.',
        'vigencia' : '20 al 31 de julio de 2026.',
        'descripcionProcedimiento' : 'Reconstrucción de concreto hidráulico de calle de la Minería y boulevard Felipe Ángeles, Fomento Minero, en el Municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }29/N67/N67.rar`,
        'start' : '2026-07-20',
        'end' : '2026-07-31',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N66-2026.',
        'vigencia' : '20 al 31 de julio de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de jardín Colón en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }29/N66/N66.rar`,
        'start' : '2026-07-20',
        'end' : '2026-07-31',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 028
        'numConvocatoria' : 'Convocatoria No. 028/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N65-2026.',
        'vigencia' : '13 al 24 de julio de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de CGI de San Felipe Orizatlán; ubicada en la localidad de Huextetitla, Municipio de San Felipe Orizatlán, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }28/N65/N65.rar`,
        'start' : '2026-07-13',
        'end' : '2026-07-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N64-2026.',
        'vigencia' : '13 al 24 de julio de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de Espacio de Atención Temporal en Huejutla de Reyes (2a etapa); ubicada en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }28/N64/N64.rar`,
        'start' : '2026-07-13',
        'end' : '2026-07-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N63-2026.',
        'vigencia' : '13 al 24 de julio de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación del CGI Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }28/N63/N63.rar`,
        'start' : '2026-07-13',
        'end' : '2026-07-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N62-2026.',
        'vigencia' : '13 al 24 de julio de 2026.',
        'descripcionProcedimiento' : 'Terminación de pavimentación de concreto asfáltico en calle Campo de Tiro, colonia San Antonio el Desmonte, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }28/N62/N62.rar`,
        'start' : '2026-07-13',
        'end' : '2026-07-24',
        'procedimiento' : 'Licitación Pública',
    },
]